import { render, staticRenderFns } from "./agent-details.vue?vue&type=template&id=382b37ac&scoped=true"
import script from "./agent-details.vue?vue&type=script&lang=js"
export * from "./agent-details.vue?vue&type=script&lang=js"
import style0 from "./agent-details.vue?vue&type=style&index=0&id=382b37ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382b37ac",
  null
  
)

export default component.exports